export default import.meta.ROLLDOWN_FILE_URL_j0WPObkrdPgUHPI7wCPj4g